import React from 'react';
import { Link } from 'react-router-dom';

import SVG from 'react-inlinesvg';
import LogoSvg from 'svg/LogoMark.svg';



const Logo = ({to = '/', showName = true, ...props}) => (
  <Link className="g-logo" to={to} {...props}>
    <SVG src={LogoSvg} />
    { showName && 
    <span>happystreams<span>.tv</span></span>}
  </Link>);


export default Logo;